import moment from 'moment-timezone'
import { TransactionReportType } from 'src/components/ReportTransactionsBoxAndLinks/reportTypes'
import { makeBaseTransactionsSchema } from 'src/components/TransactionsListFilter/transactionsFilter.schema'
import {
  TransactionDateType,
  TransactionReceiptRecoveryStatus,
  TransactionReceiptStatus,
  TransactionSort,
} from 'src/models/transaction.models'
import { accountingReviewReportsUrl } from 'src/navigation/urls'

interface AccountingPeriodBounds {
  readonly startsAt: string | number
  readonly endsAt: string | number
  readonly timezone: string
}

const getPeriodDateRange = (period: AccountingPeriodBounds) => ({
  since: moment(period.startsAt).tz(period.timezone),
  until: moment(period.endsAt).tz(period.timezone).subtract(1, 'day'),
})

const serializePeriodInstant = (instant: string | number): string =>
  typeof instant === 'number' ? new Date(instant).toISOString() : instant

export const getReceiptRecoveryTransactionsUrl = (
  status: TransactionReceiptRecoveryStatus,
  period: AccountingPeriodBounds,
): string => {
  const { since, until } = getPeriodDateRange(period)
  const filters = makeBaseTransactionsSchema({
    context: TransactionReportType.AccountingTransactions,
    expenseCategories: [],
    sort: TransactionSort.dateClearDesc,
  })
  const query = filters.stringifyFilters({
    dateType: TransactionDateType.Clear,
    receiptRecoveryStatus: new Set([status]),
    since,
    until,
    sinceClearedAtTimestamp: serializePeriodInstant(period.startsAt),
    untilClearedAtTimestamp: serializePeriodInstant(period.endsAt),
  })

  return `${accountingReviewReportsUrl()}?${query}`
}

export const getMissingReceiptTransactionsUrl = (
  period: AccountingPeriodBounds,
): string => {
  const { since, until } = getPeriodDateRange(period)
  const filters = makeBaseTransactionsSchema({
    context: TransactionReportType.AccountingTransactions,
    expenseCategories: [],
    sort: TransactionSort.dateClearDesc,
  })
  const query = filters.stringifyFilters({
    dateType: TransactionDateType.Clear,
    receiptStatus: new Set([TransactionReceiptStatus.Missing]),
    since,
    until,
    sinceClearedAtTimestamp: serializePeriodInstant(period.startsAt),
    untilClearedAtTimestamp: serializePeriodInstant(period.endsAt),
  })

  return `${accountingReviewReportsUrl()}?${query}`
}
